import { z } from "zod"
import { nonEmptyStringRequired } from "@/models/common"
import { LOOKUP_IDENTIFIER_MAXIMUM_LENGTH } from "@/modules/admin/better-doc/constants/better-doc-constants"

export const betterDocLookupSchema = z.object({
  identifier: nonEmptyStringRequired.max(LOOKUP_IDENTIFIER_MAXIMUM_LENGTH, {
    message: "admin.betterDoc.lookup.identifierTooLong",
  }),
})

export type BetterDocLookupSchema = z.infer<typeof betterDocLookupSchema>
